// material-ui
import { alpha } from '@mui/material/styles';

// project-imports
import { PopupTransition } from 'components/@extended/Transitions';

// ==============================|| OVERRIDES - DIALOG ||============================== //

export default function Dialog() {
  return {
    MuiDialog: {
      defaultProps: {
        TransitionComponent: PopupTransition,
      },
      styleOverrides: {
        root: {
          '& .MuiBackdrop-root': {
            backgroundColor: alpha('#000', 0.5),
          },
        },
        paper: {
          backgroundImage: 'none',
        },
      },
    },
  };
}
